// extracted by mini-css-extract-plugin
module.exports = {"footer":"footer_footer__4ekWH","title":"footer_title__1FUIU","description":"footer_description__24Sb5","footerlink":"footer_footerlink__27ib1"};